import { statusColors } from './components/tag'
import {
  BarChart02Icon,
  CheckCircleBrokenIcon,
  BookOpen01Icon,
  Pencil02Icon,
  DotPoints01Icon,
  Target04Icon,
  BriefCase02Icon,
  HelpCircleIcon,
} from '../assets/icons'

// removed Icon wrapper to keep icon sizes consistent across types

const typeMapping = {
  skills: {
    label: 'Skill',
    bg: statusColors.error.bg,
    borderColor: statusColors.error.border,
    color: statusColors.error.color,
    icon: <BarChart02Icon />,
  },
  competence: {
    label: 'Competence',
    bg: statusColors.warning.bg,
    borderColor: statusColors.warning.border,
    color: statusColors.warning.color,
    icon: <CheckCircleBrokenIcon />,
  },
  learning: {
    label: 'Learning',
    bg: statusColors.error.bg,
    borderColor: statusColors.error.border,
    color: statusColors.error.color,
    icon: <BookOpen01Icon />,
  },
  training: {
    label: 'Training',
    bg: statusColors.error.bg,
    borderColor: statusColors.error.border,
    color: statusColors.error.color,
    icon: <Pencil02Icon />,
  },
  task: {
    label: 'Task',
    bg: statusColors.warning.bg,
    borderColor: statusColors.warning.border,
    color: statusColors.warning.color,
    icon: <DotPoints01Icon />,
  },
  goal: {
    label: 'Goal',
    bg: statusColors.success.bg,
    borderColor: statusColors.success.border,
    color: statusColors.success.color,
    icon: <Target04Icon />,
  },
  note: {
    label: 'Note',
    bg: statusColors.warning.bg,
    borderColor: statusColors.warning.border,
    color: statusColors.warning.color,
    icon: <BookOpen01Icon />,
  },
  survey: {
    label: 'Survey',
    bg: statusColors.success.bg,
    borderColor: statusColors.success.border,
    color: statusColors.success.color,
    icon: <BriefCase02Icon />,
  },
  anonymous_survey: {
    label: 'Anonymous survey',
    bg: statusColors.success.bg,
    borderColor: statusColors.success.border,
    color: statusColors.success.color,
    icon: <HelpCircleIcon />,
  },
  form: {
    label: 'Form',
    bg: statusColors.warning.bg,
    borderColor: statusColors.warning.border,
    color: statusColors.warning.color,
    icon: <BriefCase02Icon />,
  },
}

export default typeMapping
